<template>
    <div class="animated fadeIn">
        <div class="card">
            <div class="card-header">Lastbärartillhörighet</div>
            <div class="card-body">
                <!-- <queryview qvtype="ColliBelonging" ref="blist" :selectable="true" v-on:rowclicked="onclick"
                    v-bind:currentkey="currId"> -->
                    <queryviewlistdetail qvtype="ColliBelonging" ref="blist" :selectable="true" v-on:rowclicked="onclick"
                    v-bind:currentkey="currId"
                    :detailsvisible="myModal"
                    :isBusy="isBusy"
                    >
                <template v-slot:details v-if="work">
                    <b-row>
                <b-col>
                    Kolli:
                </b-col>
                <b-col>
                    Tillhör lastbärare:
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h2>{{work.ColliId}}</h2>
                </b-col>
                <b-col>
                    <h2>{{work.BelongsToColliId}}</h2>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label>Gäller:</label> {{getDateTime(work.StartDate)}}-{{getDateTime(work.EndDate)}}
                </b-col>
            </b-row>
            <b-row>
                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Sändning" active>
                            <bookingdetails v-if="booking" v-bind:booking="booking" v-on:change="onchange"
                                :readonly="booking.Locked"></bookingdetails>

                        </b-tab>
                        <b-tab title="Lastbärarsändning">
                            <b-card-text>
                                <bookingdetails v-if="booking" v-bind:booking="belbooking" v-on:change="onchange"
                                    :readonly="belbooking.Locked"></bookingdetails>

                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
                <b-col>
                </b-col>
                <b-col>
                </b-col>
            </b-row>
                </template>
                </queryviewlistdetail>
            </div>

        </div>
    </div>
</template>
<script>
import queryviewlistdetail from "./../queryview/queryviewlistdetail";
import bookingdetails from "./../booking/bookingdetails";
import moment from "moment";

import { Api } from "../../lib/api";
const api = new Api();

export default {
    name: "collibelonginglist",
    components: { queryviewlistdetail, bookingdetails },
    data() {
        return {
            currId: null,
            myModal: false,
            work: null,
            booking: null,
            belbooking: null,
        }
    },
    methods: {
        async onclick(row) {
            this.setCurrent(row._key);
        },
        setCurrent(id) {
            this.currId = id;
            this.myModal = true;
            //this.booking = {};
            this.isBusy = true;
            api.get("/api/Booking/GetColliBelonging?id=" + this.currId).then((res) => {
                this.work = res.data;
                this.myModal = true;
                this.isBusy = false;
                //this.$forceUpdate();
                this.booking = null;
                this.belbooking = null;
                if (this.work.BookingId)
                    api.get("/api/Booking/GetDetails?id=" + this.work.BookingId).then((res) => {
                        this.booking = res.data;
                    });
                if (this.work.BelongsToBookingId)
                    api.get("/api/Booking/GetDetails?id=" + this.work.BelongsToBookingId).then((res) => {
                        this.belbooking = res.data;
                    });
            });
        },
        getDateTime(t) {
            return moment(t).format("YYYY-MM-DD hh:mm");
        }
    }
}
</script>
